/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Pr_Wins_TitleInputs */

const en_fc_vs_pr_wins_title = /** @type {(inputs: Fc_Vs_Pr_Wins_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where Premiere Pro wins`)
};

/**
* | output |
* | --- |
* | "Where Premiere Pro wins" |
*
* @param {Fc_Vs_Pr_Wins_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_pr_wins_title = /** @type {((inputs?: Fc_Vs_Pr_Wins_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Pr_Wins_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_pr_wins_title(inputs)
});
export { fc_vs_pr_wins_title as "fc.vs.pr_wins.title" }